// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { type CoinSummary } from '~/hooks/useCoins';
import { ImageIcon, type ImageIconProps } from '~/ui/ImageIcon';

// A small green "verified" checkmark badge overlaid on registered coins.
function VerifiedBadge() {
	return (
		<span className="absolute -bottom-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-success ring-2 ring-white">
			<svg viewBox="0 0 24 24" className="h-2 w-2 text-white" fill="none" stroke="currentColor">
				<path d="M5 13l4 4L19 7" strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</span>
	);
}

export function CoinAvatar({
	coin,
	name,
	size = 'md',
}: {
	coin: CoinSummary;
	name: string;
	size?: ImageIconProps['size'];
}) {
	const verified = coin.isNative || coin.metadataId != null;
	return (
		<div className="relative shrink-0">
			<ImageIcon src={coin.iconUrl} size={size} label={name} fallback={name} circle />
			{verified && <VerifiedBadge />}
		</div>
	);
}
